module.exports = __webpack_public_path__ + "img/hr-heat-pipe-t-down-1.86e663fa.png";